
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/email",
      function () {
        return require("private-next-pages/auth/email.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/email"])
      });
    }
  